
import { ammendAppUserData, getAppUserProfile } from './getProfile';

export const getClonedAppUser = (fn_cls, mainDb, database_fns, clonedUser, paps_state, callback, eventAppUsers, aps_appUserSettings) => {

  if (clonedUser) {

    const creds = { userName: clonedUser.email, phoneNumber: clonedUser.phoneNumber }
    const { pathViews } = paps_state ?? {}

    const _callback = (appUserInfo) => {
      // const appUser2 = createAppUserData(clonedUser, appUserInfo, null, null, pathViews)
      const { appUser, appUserAccess } = ammendAppUserData(clonedUser, appUserInfo, null, null, aps_appUserSettings, pathViews)
      callback && callback(appUser, appUserAccess)
    }

    getAppUserProfile(fn_cls, mainDb, database_fns, creds, pathViews, aps_appUserSettings, null, null, _callback, eventAppUsers)

  } else {

    callback({ noAuth: true })
    return {}
  }
}